<template>
    <div class="program-component">
        <card title="Sig Maintenance">
            <form>
                <fg-input v-model="sigFilter" @input="filterSigs" placeholder="Filter" class="mb-4">
                </fg-input>
                <h6>{{ isEditing ? 'Edit Short Code' : 'Add Short Code' }}</h6>
                <b-col>
                    <b-row>
                        <fg-input class="mr-1" placeholder="Short Code" v-model="newSig.shortCode" />
                        <fg-input class="mx-1" placeholder="Expansion" v-model="newSig.expansion" />
                        <fg-input class="mx-1" placeholder="Days Supply Factor (e.g., 1.0 for QD)"
                            v-model.number="newSig.daysSupplyFactor" type="number" step="0.01" />
                        <fg-input class="mx-1" placeholder="Hours of Administration (e.g., 8:00 AM,8:00 PM)"
                            v-model="newSig.hoursOfAdministration" />
                    </b-row>
                    <b-row>
                        <b-button size="sm" :variant="isEditing ? 'primary' : 'success'" @click="saveSig">
                            {{ isEditing ? 'Update' : 'Add Short Code' }}
                        </b-button>
                        <b-button v-if="isEditing" size="sm" variant="secondary" class="ml-2" @click="cancelEdit">
                            Cancel
                        </b-button>
                    </b-row>
                </b-col>
                <b-table :items="this.filteredSigs" :fields="fields" :per-page="20" :current-page="currentPage">
                    <template #cell(options)="row">
                        <b-button size="sm" variant="primary" class="mr-2" @click="editSig(row.item)">Edit</b-button>
                        <b-button size="sm" variant="danger" @click="removeSig(row)">Delete</b-button>
                    </template>
                </b-table>
                <BottomPagerBar v-model="currentPage" :total-rows="this.filteredSigs.length" :per-page="20"
                    show-total />
            </form>
        </card>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Axios from 'axios';
import { Component } from 'vue-property-decorator';
import { SigTranslation } from "@/models/SigTranslation";
import BottomPagerBar from '@/components/BottomPagerBar.vue';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: 'SigMaintenancePage',
    components: {
        BottomPagerBar
    },
})
export default class SigMaintenancePage extends Vue {

    private sigs: Array<SigTranslation> = [];
    private newSig: SigTranslation = {} as SigTranslation;
    private sigFilter: string = "";
    private currentPage = 1;
    private filteredSigs: Array<SigTranslation> = [];
    private isEditing: boolean = false;
    private fields: any[] = [
        { key: "shortCode", label: "Short Code" },
        { key: "expansion", label: "Expansion" },
        { key: "daysSupplyFactor", label: "Days Supply Factor" },
        { key: "hoursOfAdministration", label: "Hours of Administration" },
        { key: "options", label: "Actions" }
    ];
    created() {
        this.getSigs();
    }

    saveSig() {
        if (this.newSig.shortCode && this.newSig.expansion) {
            if (this.isEditing) {
                // Update existing sig
                Axios.post('SigTranslation/Edit', this.newSig).then(response => {
                    this.getSigs();
                    this.$notification(NotificationOptions.success("Sig Updated"));
                    this.clearForm();
                }).catch(error => {
                    console.error(error);
                    this.$notification(NotificationOptions.error(error));
                });
            } else {
                // Add new sig
                Axios.post('SigTranslation/Add', this.newSig).then(response => {
                    this.getSigs();
                    this.$notification(NotificationOptions.success("Sig Added"));
                    this.clearForm();
                }).catch(error => {
                    console.error(error);
                    this.$notification(NotificationOptions.error(error));
                });
            }
        }
    }

    editSig(sig: SigTranslation) {
        this.newSig = { ...sig };
        this.isEditing = true;
    }

    cancelEdit() {
        this.clearForm();
    }

    clearForm() {
        this.newSig = {} as SigTranslation;
        this.isEditing = false;
    }

    getSigs() {
        Axios.get('SigTranslation/')
            .then(response => {
                this.sigs = response.data;
                if (this.sigFilter != "") {
                    this.filterSigs();
                }
                else {
                    this.filteredSigs = response.data;
                }
            })
            .catch(error => {
                console.warn(error);
            });
    }

    removeSig(sigId: any) {
        Axios.post('SigTranslation/Remove/' + sigId.item.id)
            .then(() => {
                this.getSigs();
                this.$notification(NotificationOptions.success("Sig Removed"));
            })
            .catch(error => {
                this.$notification(NotificationOptions.error(error));
            });
    }

    filterSigs() {
        if (this.sigFilter != "") {
            this.filteredSigs = this.sigs.filter(s => s.expansion.includes(this.sigFilter.toUpperCase()) || s.shortCode.includes(this.sigFilter.toUpperCase()));
        }
        if (this.sigFilter == "")
            this.filteredSigs = this.sigs;

    }
}

</script>

<style scoped></style>
